<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>用户管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.role"
          >
            <option value="">请选择角色</option>
            <option
              v-for="(val,key) in dict_role"
              :key="key"
              :value="key"
            >{{val}}</option>

          </select>
          <select
            :disabled="[2,3,4,11,12].indexOf(localUser.role) >= 0"
            class="s-select separate"
            v-model="queryInfo.province"
            @change="getSchool(queryInfo.province,1)"
          >
            <option value=''>请选择省份</option>
            <option
              :value="key"
              v-for="(val, key) in provinceData"
              :key="key"
            >{{ val }}</option>
          </select>
          <select
            :disabled="[3,4,11,12].indexOf(localUser.role) >= 0"
            class="s-select separate"
            v-model="queryInfo.school_id"
            @change="getAcademy(queryInfo.school_id,1)"
          >
            <option value=''>请选择学校</option>
            <option
              v-for="(item, index) in searceSchoolData"
              :key="index"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            :disabled="[4,11,12].indexOf(localUser.role) >= 0"
            class="s-select separate"
            v-model="queryInfo.academy_id"
            @change="getQueryMajor(queryInfo.academy_id,1)"
          >
            <option value=''>请选择院系</option>
            <option
              v-for="item in searchAcademyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.major_id"
          >
            <option value=''>请选择专业</option>
            <option
              v-for="item in querymajorData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            class="s-select separate"
            v-model="queryInfo.is_active"
          >
            <option value=''>请选择状态</option>
            <option :value="0">禁用</option>
            <option :value="1">启用</option>
          </select>
          <input
            type="text"
            placeholder="用户名(学/工号)"
            class="s-input separate"
            v-model="queryInfo.username"
            autocomplete="off"
          />
          <input
            type="text"
            placeholder="姓名"
            class="s-input separate"
            v-model="queryInfo.name"
            autocomplete="off"
          />
          <input
            type="text"
            placeholder="手机"
            class="s-input separate"
            v-model="queryInfo.mobile"
            autocomplete="off"
          />
          <input
            type="button"
            value="搜索"
            class="s-btn"
            @click="pageCallback(1)"
          />
        </div>
        <hr />
        <div class="search-line clearfix">
          <div
            class="add-btn"
            style="margin-bottom: 0"
            @click="showAddWindow('add')"
          >
            添加用户
          </div>
          <div
            class="import-btn"
            id="batchUpload"
            @click="showUploadWindow"
          >
            导入
          </div>
        </div>
      </div>
      <div id="list">
        <table v-if="tableData.length > 0">
          <tbody>
            <tr class="l_header">
              <th width="35px">
                <a
                  href="javascript:;"
                  class="a-link"
                  @click="ckAll"
                >全选</a>
              </th>
              <th class="itemStatus">用户名</th>
              <th class="itemStatus">姓名</th>
              <th class="itemStatus">手机号</th>
              <th class="itemStatus">性别</th>
              <th class="itemStatus">所属省份</th>
              <th class="itemStatus">学校</th>
              <th class="itemStatus">院系</th>
              <th class="itemStatus">专业</th>
              <th class="itemStatus">角色</th>
              <th class="itemStatus">状态</th>
              <th class="itemStatus">是否绑定手机</th>
              <th
                class="action"
                width="130"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="item in tableData"
              :key="item.id"
            >
              <td>
                <input
                  type="checkbox"
                  :value="item.id"
                  v-model="ckUser"
                />
              </td>
              <td class="itemStatus">{{ item.username }}</td>
              <td class="itemStatus">{{ item.name }}</td>
              <td class="itemStatus">{{ item.mobile ? item.mobile : "--" }}</td>
              <td class="itemStatus">{{ genderFormater(item.gender) }}</td>
              <td class="itemStatus">{{ formatProvince(item.province) }}</td>
              <td class="itemStatus">
                {{ item.school ? item.school.title : "--" }}
              </td>
              <td class="itemStatus">
                {{ item.academy ? item.academy.title : "--" }}
              </td>
              <td class="itemStatus">
                {{ item.major ? item.major.title : "--" }}
              </td>
              <td class="itemStatus">{{ roleFormater(item.role) }}</td>
              <td :class="'itemStatus itemStatus' + (2 - item.is_active)">
                {{ item.is_active == 0 ? "已禁用" : "已启用" }}
              </td>
              <td class="itemStatus">{{ item.mobile_status == 1 ? "是" : "否" }}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="querySingle(item.id)"
                >编辑</a>
                <a
                  v-if="item.is_active == 1"
                  class="disable"
                  href="javascript:;"
                  @click="askDisable(item, 0)"
                >禁用</a>
                <a
                  v-if="item.is_active == 0"
                  class="undisable"
                  href="javascript:;"
                  @click="askDisable(item, 1)"
                >启用</a>
                <a
                  class="other1"
                  href="javascript:;"
                  @click="askResetPwd(item)"
                >重置密码</a>
                <a
                  class="other1"
                  href="javascript:;"
                  @click="showBindWindow(item)"
                >是否绑定手机</a>
                <a
                  class="other1"
                  href="javascript:;"
                  @click="askClearMobile(item)"
                >清除手机号</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 批量按钮 -->
      <ul
        class="batchBtns"
        id="batchBtns"
      >
        <li>
          <input
            type="button"
            class="disable-btn"
            id="batchDisableBtn"
            value="批量禁用"
            @click="batchDisable"
          />
        </li>
        <li>
          <input
            type="button"
            class="enable-btn"
            id="batchEnableBtn"
            value="批量启用"
            @click="batchUnDisable"
          />
        </li>
      </ul>
      <!-- 分页 -->
      <pagination
        :cur="pageInfo.page"
        :all="pageInfo.all"
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
      <!-- 用户添加/编辑弹窗 -->
      <div
        class="form_overlay"
        :style="classShowAddWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">用户管理</div>
          <div class="form_content">
            <form id="itemForm">
              <div class="item">
                <span class="label"> <i class="require">*</i>角色: </span>
                <input
                  type="hidden"
                  v-model="formInfo.id"
                />
                <select
                  v-model="formInfo.role"
                  @change="selectRole"
                  autocomplete="off"
                >
                  <option value=''>请选择角色</option>
                  <option
                    v-for="(val,key) in dict_role"
                    :key="key"
                    :value="key"
                  >{{val}}</option>
                </select>
              </div>
              <div class="item">
                <span class="label"> <i class="require">*</i>用户名(学/工号): </span>
                <input
                  type="text"
                  v-model="formInfo.username"
                  autocomplete="off"
                  :disabled="isEnable"
                />
              </div>
              <div class="item">
                <span class="label"> <i class="require">*</i>姓名: </span>
                <input
                  type="text"
                  v-model="formInfo.name"
                  autocomplete="off"
                  maxlength="25"
                />
              </div>
              <div class="item">
                <span class="label">手机:</span>
                <input
                  type="text"
                  v-model="formInfo.mobile"
                  autocomplete="off"
                  maxlength="11"
                />
              </div>
              <div class="item">
                <span class="label">性别:</span>
                <select v-model="formInfo.gender">
                  <option value=''>未知</option>
                  <option value="1">男</option>
                  <option value="0">女</option>
                </select>
              </div>
              <div class="item">
                <span class="label"> <i class="require">*</i>省份: </span>
                <select
                  :disabled="[2,3,4,10,11,12].indexOf(localUser.role) >= 0"
                  v-model="formInfo.province"
                  @change="getSchool(formInfo.province)"
                >
                  <option value="">请选择省份</option>
                  <option
                    :value="key"
                    v-for="(val, key) in provinceData"
                    :key="key"
                  >{{ val }}</option>
                </select>
              </div>
              <div
                class="item"
                v-if="showSchool"
              >
                <span class="label"> <i class="require">*</i>学校: </span>
                <select
                  :disabled="[3,4,11,12].indexOf(localUser.role) >= 0"
                  v-model="formInfo.school_id"
                  @change="getAcademy(formInfo.school_id)"
                >
                  <option value=''>请选择学校</option>
                  <option
                    v-for="(item, index) in schoolData"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
              <div
                class="item"
                v-if="showAcademy"
              >
                <span class="label"> <i class="require">*</i>院系: </span>
                <select
                  :disabled="[4,11,12].indexOf(localUser.role) >= 0"
                  v-model="formInfo.academy_id"
                  @change="getMajor(formInfo.academy_id)"
                >
                  <option value="">请选择院系</option>
                  <option
                    v-for="item in academyData"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
              <div
                class="item"
                v-if="showMajor"
              >
                <span class="label">专业: </span>
                <select v-model="formInfo.major_id">
                  <option value=''>请选择专业</option>
                  <option
                    v-for="item in majorData"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              id="form_close"
              @click="hideAddWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              id="form_submit"
              @click="saveInfo"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        class="form_overlay"
        :style="classShowUploadWindow"
      >
        <div class="form_overlay_bg"></div>
        <div class="form_panel">
          <div class="form_title">批量上传</div>
          <div class="form_content">
            <form id="uploadForm">
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require"></i>模版创建规则:
                </span>
                <div class="item-box divLabel gray">
                  <div class="normal-width">
                    <p>
                      1. 文件格式为常用的Excel文件（*.xls）；
                    </p>
                    <p>
                      2.填写导入数据时，需先删除导入模版中首行以下所有说明示例数据；
                    </p>
                    <p>
                      3.导入的数据总条数建议不超过500条，如超过，建议分多次导入；
                    </p>
                    <p>
                      4.表格头说明：角色、用户名(学/工号)、姓名、手机号、邮箱、省份、学校(学院、专业);
                    </p>
                  </div>
                </div>
                <div class="clear"></div>
                <div class="attachment">
                  <a
                    href="/static/upload_template/batch_upload_user_template_v2.xls"
                    download="batch_upload_user_template_v2.xls"
                    target="_blank"
                  >模版下载</a>
                </div>
              </div>
              <div class="item">
                <span
                  class="label"
                  style="width: auto"
                >
                  <i class="require">*</i>xls文件:
                </span>
                <div
                  class="item-box"
                  style="margin-left: 130px"
                >
                  <input
                    v-model="uploadedCsv"
                    disabled
                    type="text"
                    id="fileUrl"
                    style="width: 225px"
                  />
                  <span
                    class="button"
                    style="position: relative; top: 0px; left: 0px"
                  >
                    选择文件
                    <input
                      @change="xlsChange"
                      type="file"
                      accept=".csv,.xls,.xlsx"
                      ref="xlsFile"
                      id="fileUpload"
                      class="upload-derict"
                    />
                  </span>
                </div>
                <div class="clear"></div>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              style="width: 30px"
              class="button close"
              id="form_upload_close"
              @click="hideUploadWindow"
            >取消</a>
            <a
              href="javascript:;"
              style="width: 30px"
              class="button"
              id="form_upload_submit"
              @click="submitCsv"
            >提交</a>
          </div>
        </div>
      </div>
      <div
        id="dialog_overlay"
        :style="classShowProcessWindow"
      >
        <div id="dialog_bg"></div>
        <div
          id="dialog_panel"
          ref="refErrorList"
          style="margin-left: -136px; margin-top: -54px;max-width: 300px;"
        >
          <div id="dialog_panel_bg"></div>
          <div id="dialog_title">提示</div>
          <div id="dialog_content">
            ({{ curCsvIndex }} / {{ uploadedCscData.length }})
            <span style="color: #219d2b">
              {{ ' ' + csvFinishText }}
            </span>
          </div>
          <div id="dialog_content2">
            <ul>
              <li
                v-for="(item, index) in errorList"
                v-bind:key="index"
              >
                <span :class="item.code == 1 ? 'success' : 'fail'">{{ item.text }}</span>
              </li>
            </ul>

          </div>
          <div id="dialog_control">
            <a
              href="javascript:void(0)"
              id="dialog_ok"
              class="button col2"
              @click="classShowProcessWindow={}"
              :style="isFinishUpsert ? 'display: inline-block' : 'display:none'"
            >确认</a>
          </div>
        </div>
      </div>
      <!-- 是否绑定手机窗体 -->
      <div
        class="form_overlay"
        :style="classShowBind"
      >
        <div class="form_overlay_bg"></div>
        <!-- 学校管理 -->
        <div class="form_panel">
          <div class="form_title">设置是否绑定手机</div>
          <div class="form_content">
            <form>
              <div class="item">
                <span class="label"><i class="require">*</i>是否绑定手机:</span>
                <select v-model="formBind.mobile_status">
                  <option value="1">是</option>
                  <option value="0">否</option>
                </select>
              </div>
            </form>
          </div>
          <div class="form_control">
            <a
              href="javascript:;"
              class="button close"
              @click="hideBindWindow"
            >取消</a>
            <a
              href="javascript:;"
              class="button"
              @click="saveBind"
            >提交</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'User',
  components: {
    Pagination
  },
  data() {
    return {
      ckUser: [],
      classShowAddWindow: {},
      classShowBind: {},
      classShowUploadWindow: {},
      tableData: [],
      queryInfo: {
        page: 1,
        size: 10,
        role: '',
        academy_id: '',
        major_id: '',
        province: '',
        school_id: '',
        is_active: '',
        username: '',
        name: '',
        mobile: ''
      },
      formInfo: {
        role: '',
        username: '',
        name: '',
        gender: '',
        mobile: '',
        is_active: 1,
        isdel: 0,
        province: '',
        school_id: '',
        academy_id: '',
        major_id: ''
      },
      formBind: {
        id: 0,
        mobile_status: 0
      },
      showSchool: false,
      showAcademy: false,
      showMajor: false,
      tableDataCount: 0,
      // uploadedCsv: '',
      academyData: [],
      searchAcademyData: [],
      majorData: [],
      querymajorData: [],
      allMajorData: [],
      isEnable: false,
      schoolData: [],
      searceSchoolData: [],

      uploadedCsv: '',
      uploadedCscData: [],
      classShowProcessWindow: {},
      isFinishUpsert: false,
      curCsvIndex: 0,
      csvFinishText: '',
      errorList: [],
      isRepeat: false
    }
  },
  methods: {
    async mobileRepeat() {
      await this.$http.get('/userprofile/', {
        params: {
          eq_mobile: this.formInfo.mobile
        }
      }).then((data) => {
        if (data.results.length) {
          this.isRepeat = true
        } else {
          this.isRepeat = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    formatProvince(value) {
      return value ? this.$store.state.dict_province[value] : '--'
    },
    genderFormater(value) {
      if (value === '0') {
        return '女'
      } else if (value === '1') {
        return '男'
      } else {
        return '--'
      }
    },
    async getAllMajor() {
      await this.$http.get('/major/', {
        params: {
          size: 10000
        }
      }).then((data) => {
        this.allMajorData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    roleFormater(role) {
      return this.all_role[role]
    },
    selectRole(e) {
      if (e.target.value === '2') {
        this.showSchool = false
        this.showAcademy = false
        this.showMajor = false
        this.formInfo.school_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      } else if (e.target.value === '3') {
        this.showSchool = true
        this.showAcademy = false
        this.showMajor = false
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      } else if (e.target.value === '4') {
        this.showSchool = true
        this.showAcademy = true
        this.showMajor = true
        this.showMajor = false
        this.formInfo.major_id = ''
      } else if (e.target.value === '10') {
        this.showSchool = false
        this.showAcademy = false
        this.showMajor = false
        this.showMajor = false
        this.formInfo.school_id = ''
        this.formInfo.major_id = ''
      } else if (e.target.value === '11') {
        this.showSchool = true
        this.showAcademy = true
        this.showMajor = true
        this.showMajor = false
        this.formInfo.major_id = ''
      } else if (e.target.value === '12') {
        this.showSchool = true
        this.showAcademy = true
        this.showMajor = true
        this.showMajor = true
        this.formInfo.major_id = ''
      } else {
        this.showSchool = false
        this.showAcademy = false
        this.showMajor = false
        this.formInfo.school_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      }
      this.formInfo.province = this.localUser.province
      this.getSchool(this.formInfo.province)
    },
    async getSchool(value, category) {
      const params = {
        page: 1,
        size: 10000,
        province: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/school/', { params }).then((data) => {
          if (category) {
            this.searceSchoolData = data.results
            this.searchAcademyData = []
            this.querymajorData = []
            this.queryInfo.school_id = ''
            this.queryInfo.academy_id = ''
            this.queryInfo.major_id = ''
          } else {
            this.schoolData = data.results
            this.majorData = []
            this.academyData = []
            this.formInfo.school_id = ''
            this.formInfo.academy_id = ''
            this.formInfo.major_id = ''
          }
          if ([3, 4, 11].indexOf(this.localUser.role) >= 0) {
            this.queryInfo.school_id = this.localUser.school_id
            this.formInfo.school_id = this.localUser.school_id
          }
          if ([3].indexOf(this.localUser.role) >= 0) {
            this.getAcademy(this.formInfo.school_id)
            this.getAcademy(this.queryInfo.school_id, 1)
          }
          if ([4, 11].indexOf(this.localUser.role) >= 0) {
            this.queryInfo.academy_id = this.localUser.academy_id
            this.formInfo.academy_id = this.localUser.academy_id
            this.getAcademy(this.queryInfo.school_id, 1)
            this.getAcademy(this.queryInfo.school_id)
            this.getQueryMajor(this.queryInfo.academy_id, 1)
            this.getQueryMajor(this.queryInfo.academy_id)
            this.getMajor(this.formInfo.academy_id)
          }
          if ([11].indexOf(this.localUser.role) >= 0) {
            this.getMajor(this.formInfo.academy_id, 1)
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searceSchoolData = []
        this.searchAcademyData = []
        this.querymajorData = []
        this.majorData = []
        this.academyData = []
        this.schoolData = []
        this.queryInfo.school_id = ''
        this.queryInfo.academy_id = ''
        this.queryInfo.major_id = ''
        this.formInfo.school_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      }
    },
    // 获取所有院系
    async getAcademy(value, category) {
      const params = {
        page: 1,
        size: 10000,
        school_id: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/academy/', { params }).then((data) => {
          if (category) {
            this.searchAcademyData = data.results
          } else {
            this.academyData = data.results
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searchAcademyData = []
        this.academyData = []
        this.querymajorData = []
        this.majorData = []
        this.queryInfo.academy_id = ''
        this.queryInfo.major_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      }
    },
    // 获取院系下面所有的专业
    async getQueryMajor(value) {
      const params = {
        academy_id: value,
        page: 1,
        size: 10000
      }
      if (value) {
        await this.$http.get('/major/', { params }).then((data) => {
          this.querymajorData = data.results
        }).catch((error) => {
          this.$parent.showMsg('该院系下暂未设置专业')
          console.log(error)
        })
      } else {
        this.querymajorData = []
        this.queryInfo.major = ''
      }
    },
    async getMajor(val) {
      const params = {
        academy_id: val,
        page: 1,
        size: 10000
      }
      if (val) {
        await this.$http.get('/major/', { params }).then((data) => {
          this.majorData = data.results
        }).catch((error) => {
          this.$parent.showMsg('该院系下暂未设置专业')
          console.log(error)
        })
      } else {
        this.majorData = []
        this.formInfo.major_id = ''
      }
    },
    async search() {
      if (parseInt(this.localUser.role) === 1) {
        this.queryInfo.academy_id = this.localUser.academy_id
      }
      await this.$http.get('/userprofile/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    // 全选
    ckAll() {
      if (this.ckUser.length === this.tableData.length) {
        this.ckUser = []
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          this.ckUser.push(this.tableData[i].id)
        }
      }
    },
    async xlsChange(e) {
      const uploadUrl = '/files/' + e.target.files[0].name
      await this.$http.put(uploadUrl, e.target.files[0]).then((data) => {
        this.uploadedCsv = data
        e.srcElement.value = null
      }).catch(() => {
        this.$parent.showMsg('上传失败！')
      })
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    // 打开用户添加/编辑弹窗
    showAddWindow(value) {
      if (value === 'add') {
        this.formInfo = {
          role: '',
          username: '',
          name: '',
          gender: '',
          mobile: '',
          is_active: 1,
          isdel: 0,
          province: '36',
          school_id: '',
          academy_id: '',
          major_id: ''
        }
      }
      if ([2, 10, 3, 4, 11].indexOf(this.localUser.role) >= 0) {
        this.formInfo.province = this.localUser.province
        this.getSchool(this.formInfo.province)
      }
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    // 关闭用户添加/编辑弹窗
    hideAddWindow() {
      this.classShowAddWindow = {}
      this.formInfo = {
        role: '',
        username: '',
        name: '',
        gender: '',
        mobile: '',
        is_active: 1,
        isdel: 0,
        province: '',
        school_id: '',
        academy_id: '',
        major_id: ''
      }
      this.showSchool = false
      this.showAcademy = false
      this.showMajor = false
      this.isEnable = false
    },
    // 打开绑定手机窗体
    showBindWindow(item) {
      this.formBind.id = item.id
      this.formBind.mobile_status = item.mobile_status === 1 ? 1 : 0
      this.classShowBind = {
        visibility: 'visible'
      }
    },
    // 关闭绑定手机窗体
    hideBindWindow() {
      this.classShowBind = {}
    },
    // 打开上传弹窗
    showUploadWindow() {
      this.classShowUploadWindow = {
        visibility: 'visible'
      }
    },
    // 关闭上传弹窗
    hideUploadWindow() {
      this.classShowUploadWindow = {}
    },
    // 保存
    async saveInfo() {
      if (this.formInfo.mobile.length) {
        await this.mobileRepeat()
      }
      if (!this.formInfo.role) {
        this.$parent.showMsg('请选择角色!')
        return false
      }
      if (!this.formInfo.username) {
        this.$parent.showMsg('请输入用户名(学/工号)!')
        return false
      }
      if (this.formInfo.username.length <= 3) {
        this.$parent.showMsg('用户名(学/工号)长度必须大于4位!')
        return false
      }
      if (this.formInfo.username.length >= 50) {
        this.$parent.showMsg('用户名(学/工号)长度必须小于50位!')
        return false
      }
      const re = /^[A-Za-z0-9]*$/
      if (re.test(this.formInfo.username) === false) {
        this.$parent.showMsg('用户名(学/工号)只能包含字母和数字!')
        return false
      }

      if (!this.formInfo.name) {
        this.$parent.showMsg('请输入姓名!')
        return false
      }
      if (this.formInfo.name.trim().length < 2) {
        this.$parent.showMsg('姓名必须大于2位!')
        return false
      }
      if (this.formInfo.name.trim().length > 20) {
        this.$parent.showMsg('姓名过长!')
        return false
      }
      const mobileReg = /^1[0-9]{10}$/
      if (this.formInfo.mobile.length > 0 && !mobileReg.test(this.formInfo.mobile)) {
        this.$parent.showMsg('手机号码输入错误！')
        return false
      }
      if (this.formInfo.mobile.length > 0 && this.isRepeat) {
        this.$layer.msg('手机号已被绑定，请重新输入！')
        return
      }
      if ([4, 11, 12].indexOf(Number(this.formInfo.role)) >= 0 && !this.formInfo.province) {
        this.$parent.showMsg('请选择省份!')
        return false
      }
      if ([3, 4, 11, 12].indexOf(Number(this.formInfo.role)) >= 0 && !this.formInfo.school_id) {
        this.$parent.showMsg('请选择学校!')
        return false
      }
      if ([4, 11, 12].indexOf(Number(this.formInfo.role)) >= 0 && !this.formInfo.academy_id) {
        this.$parent.showMsg('请选择院系!')
        return false
      }
      // if ([12].indexOf(Number(this.formInfo.role)) >= 0 && !this.formInfo.major_id) {
      //   this.$parent.showMsg('请选择专业!')
      //   return false
      // }
      this.formInfo.academy_id = this.formInfo.academy_id ? this.formInfo.academy_id : null
      this.formInfo.major_id = this.formInfo.major_id ? this.formInfo.major_id : null
      this.formInfo.school_id = this.formInfo.school_id ? this.formInfo.school_id : null
      if (this.formInfo.id) {
        const url = '/userprofile/' + this.formInfo.id + '/'

        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.search()
            this.hideAddWindow()
          } else {
            this.$parent.showMsg(data[0])
          }
        }).catch((error) => {
          this.$parent.showMsg(error.response.data[0])
        })
      } else {
        await this.$http.post('/userprofile/', this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.search()
            this.hideAddWindow()
          } else {
            this.$parent.showMsg(data[0])
          }
        }).catch((error) => {
          this.$parent.showMsg(error.response.data[0])
        })
      }
    },
    // 编辑时查询
    async querySingle(id) {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
      const url = '/userprofile/' + id + '/'
      await this.$http.get(url).then(async (data) => {
        this.isEnable = true
        this.formInfo.id = data.id
        this.formInfo.role = data.role
        this.formInfo.username = data.username
        this.formInfo.name = data.name
        this.formInfo.gender = data.gender ? data.gender : ''
        this.formInfo.mobile = data.mobile
        this.formInfo.is_active = data.is_active
        this.formInfo.isdel = data.isdel
        this.formInfo.province = data.province ? data.province : ''
        await this.getSchool(this.formInfo.province)
        this.formInfo.school_id = data.school_id ? data.school_id : ''
        await this.getAcademy(this.formInfo.school_id)
        this.formInfo.academy_id = data.academy_id ? data.academy_id : ''
        await this.getMajor(this.formInfo.academy_id)
        this.formInfo.major_id = data.major_id ? data.major_id : ''
        if (data.role === '2') {
          this.showSchool = false
          this.showAcademy = false
          this.showMajor = false
        } else if (data.role === '3') {
          this.showSchool = true
          this.showAcademy = false
          this.showMajor = false
        } else if (data.role === '4') {
          this.showSchool = true
          this.showAcademy = true
          this.showMajor = true
          this.showMajor = false
        } else if (data.role === '10') {
          this.showSchool = false
          this.showAcademy = false
          this.showMajor = false
          this.showMajor = false
        } else if (data.role === '11') {
          this.showSchool = true
          this.showAcademy = true
          this.showMajor = true
          this.showMajor = false
        } else if (data.role === '12') {
          this.showSchool = true
          this.showAcademy = true
          this.showMajor = true
          this.showMajor = true
        } else {
          this.showSchool = false
          this.showAcademy = false
          this.showMajor = false
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 批量禁用
    batchDisable() {
      if (this.ckUser.length === 0) {
        this.$parent.showMsg('请先选择记录')
      } else {
        this.$parent.showConfirm('确认将所选用户批量禁用？', async () => {
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.ckUser.indexOf(this.tableData[i].id) >= 0) {
              await this.doDisable(this.tableData[i], 0, false)
            }
          }
          await this.search()
          this.ckUser = []
          this.$layer.msg('操作成功！')
        })
      }
    },
    // 批量启用该
    batchUnDisable() {
      if (this.ckUser.length === 0) {
        this.$parent.showMsg('请先选择记录')
      } else {
        this.$parent.showConfirm('确认将所选用户批量启用？', async () => {
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.ckUser.indexOf(this.tableData[i].id) >= 0) {
              await this.doDisable(this.tableData[i], 1, false)
            }
          }
          await this.search()
          this.ckUser = []
          this.$layer.msg('操作成功！')
        })
      }
    },
    // 禁用
    async doDisable(item, userValue, showMsg) {
      const url = '/userprofile/' + item.id + '/'
      await this.$http.put(url, {
        username: item.username,
        is_active: userValue
      }).then((data) => {
        if (showMsg) {
          this.$layer.msg('操作成功！')
        }
      }).catch((error) => {
        this.$parent.showMsg(error.response.data)
      })
    },
    askDisable(item, userValue) {
      const msg = userValue === 0 ? '确定要禁用吗？' : '确定要启用吗？'
      this.$parent.showConfirm(msg, async () => {
        await this.doDisable(item, userValue, true)
        await this.search()
      })
    },
    // 密码重置
    async askResetPwd(item) {
      this.$parent.showConfirm('确定要重置密码？', () => {
        this.resetPwd(item)
      })
    },
    async resetPwd(item) {
      const url = '/userprofile/' + item.id + '/'
      await this.$http.put(url, {
        username: item.username,
        password1: this.utils.encryptDes('Bjjt**vr'),
        password2: this.utils.encryptDes('Bjjt**vr')
      }).then(async (data) => {
        if (data.id) {
          this.$layer.msg('重置密码成功，新密码是【Bjjt**vr】！')
        } else {
          this.$layer.msg('重置密码失败！')
        }
      }).catch((error) => {
        console.dir(error)
        this.$layer.msg('重置密码失败！')
      })
    },
    async submitCsv() {
      this.errorList = []
      const uploadUrl = '/get_excel/'
      await this.$http.get(uploadUrl, {
        params: {
          file_name: this.uploadedCsv
        }
      }).then((data) => {
        if (data.length <= 1) {
          this.$parent.showMsg('表格中无数据！')
          return
        }
        if (data.length > 501) {
          this.$parent.showMsg('表格中数据大于500条，请分批上传！')
          return
        }
        data.splice(0, 1)
        this.uploadedCscData = data
        this.hideUploadWindow()
        this.classShowProcessWindow = {
          visibility: 'visible'
        }
        this.uploadedCsv = ''
        this.isFinishUpsert = false
        this.curCsvIndex = 0
        this.csvFinishText = ''
        this.errorList = []
        this.insertOne()
      }).catch(() => {
        this.$parent.showMsg('读取失败！')
      })
    },
    async insertOne() {
      if (this.curCsvIndex >= this.uploadedCscData.length) {
        this.csvFinishText = '上传完成'
        this.isFinishUpsert = true
        this.search()
        return
      }

      const row = this.uploadedCscData[this.curCsvIndex]
      // const academy = this.academyData.map(item => item.title)
      // const userData = this.tableData.map(item => item.username)
      // let usernameValid = false
      // let province = '', school = ''
      // region 数据检查开始

      if (row[0].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[0] + ']' + '请输入角色！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[1].toString().trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[1] + ']' + '请输入用户名(学/工号)！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      const re = /^[A-Za-z0-9]*$/
      if (re.test(row[1].toString().trim()) === false) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[1] + ']' + '用户名(学/工号)只能包含字母和数字' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[2].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[2] + ']' + '请输入姓名！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[5].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[5] + ']' + '请输入省份！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      if (row[6].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[6] + ']' + '请输入学校！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      if ((row[0] === '教师' || row[0] === '学生') && row[7].trim().length === 0) {
        this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[7] + ']' + '请输入院系！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }
      // if (row[0] === '学生' && row[8].trim().length === 0) {
      //   this.errorList.push({ code: 0, text: '第[' + (this.curCsvIndex + 1) + ']行[' + row[8] + ']' + '请输入专业！' })
      //   this.curCsvIndex++
      //   await this.insertOne()
      //   return
      // }

      const roleArr = [
        '超级管理员',
        '省管理员',
        '校管理员',
        '院系管理员',
        '运营管理员',
        '教师',
        '学生'
      ]

      if (roleArr.indexOf(row[0]) < 0) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '角色输入错误！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      let role = ''
      if (row[0] === '超级管理员') {
        role = '0'
      } else if (row[0] === '省管理员') {
        role = '2'
      } else if (row[0] === '校管理员') {
        role = '3'
      } else if (row[0] === '院系管理员') {
        role = '4'
      } else if (row[0] === '运营管理员') {
        role = '10'
      } else if (row[0] === '教师') {
        role = '11'
      } else if (row[0] === '学生') {
        role = '12'
      }
      const schoolCheckData = await this.$http.get('/school/', {
        params: {
          eq_title: row[6]
        }
      })

      let province = ''
      debugger
      for (const key in this.provinceData) {
        if (this.provinceData[key] === row[5]) {
          province = key
        }
      }

      let school = ''
      if (schoolCheckData.results.length === 0) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '学校错误，当前学校不存在！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      } else {
        school = schoolCheckData.results[0].id
      }

      const academyCheckData = await this.$http.get('/academy/', {
        params: {
          page: 1,
          size: 10000,
          school_id: school,
          status: 1,
          eq_title: row[7]
        }
      })
      let academy = null
      if (row[0] === '教师' || row[0] === '学生') {
        if (academyCheckData.results.length === 0) {
          this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '院系错误，当前院系不存在！' })
          this.curCsvIndex++
          await this.insertOne()
          return
        } else {
          academy = academyCheckData.results[0].id
        }
      }

      const majorCheckData = await this.$http.get('/major/', {
        params: {
          academy_id: academy,
          page: 1,
          size: 10000,
          eq_title: row[8]
        }
      })
      let major = null

      if (majorCheckData.results.length > 0) {
        major = majorCheckData.results[0].id
      }

      const pwd = row[9]
      var testPassword = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,64}$/
      var Email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (pwd.trim() === '') {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '请输入密码！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      } else if (testPassword.test(pwd) === false) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '密码须同时包含大写字母、小写字母、数字、特殊字符中的任意三种！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      } else if (Email.test(pwd) === true) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '密码不能是邮箱！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      } else if (pwd.length < 8) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '密码至少8位！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      } else if (pwd.length > 64) {
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + '密码最多64位！' })
        this.curCsvIndex++
        await this.insertOne()
        return
      }

      // endregion 数据检查结束

      await this.$http.post('/userprofile/', {
        role: role,
        username: row[1],
        name: row[2],
        mobile: row[3],
        emailInfo: row[4],
        province: province,
        school_id: school,
        password1: this.utils.encryptDes(pwd),
        password2: this.utils.encryptDes(pwd),
        academy_id: academy,
        major_id: major
      }).then((profileData) => {
        this.errorList.push({ code: 1, text: '[' + row[1] + ']' + '导入成功！' })
        this.curCsvIndex++
        this.insertOne()
      }).catch((error) => {
        console.log(error)
        this.errorList.push({ code: 0, text: '[' + row[1] + ']' + error.response.data[0] })
        this.curCsvIndex++
        this.insertOne()
      })
    },
    async saveBind() {
      const url = '/userprofile/' + this.formBind.id + '/'
      await this.$http.put(url, {
        mobile_status: this.formBind.mobile_status
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('操作成功！')
          this.hideBindWindow()
          this.search()
        }
      }).catch((error) => {
        this.$parent.showMsg(error.response.data)
      })
    },
    async doClearMobile(item) {
      const url = '/userprofile/' + item.id + '/'
      await this.$http.put(url, {
        mobile_status: 0,
        mobile: ''
      }).then((data) => {
        if (data.id) {
          this.$layer.msg('操作成功！')
        }
      }).catch((error) => {
        this.$parent.showMsg(error.response.data)
      })
    },
    askClearMobile(item) {
      this.$parent.showConfirm('确定要清除用户【' + item.name + '】的手机号？', async () => {
        await this.doClearMobile(item)
        await this.search()
      })
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    },
    provinceData() {
      return this.$store.state.dict_province
    },
    dict_role() {
      if (this.$store.state.platform_level === 3) {
        return {
          3: '校管理员',
          4: '院系管理员',
          10: '运营管理员',
          11: '教师',
          12: '学生'
        }
      } else if (this.$store.state.platform_level === 4) {
        return {
          4: '院系管理员',
          10: '运营管理员',
          11: '教师',
          12: '学生'
        }
      } else {
        return {}
      }
    },
    all_role() {
      return this.$store.state.dict_role
    }
  },
  async created() {
    // if ([2, 10, 3, 4, 11].indexOf(this.localUser.role) >= 0) {
    //   this.queryInfo.province = this.localUser.province
    //   await this.getSchool(this.queryInfo.province, 1)
    // }
    this.queryInfo.province = this.localUser.province
    this.getSchool(this.queryInfo.province, 1)
    if (this.localUser.school_id) {
      this.queryInfo.school_id = this.localUser.school_id
    }
    if (this.localUser.academy_id) {
      this.queryInfo.academy_id = this.localUser.academy_id
    }
    if (this.localUser.major_id) {
      this.queryInfo.major_id = this.localUser.major_id
    }
    await this.search()
  },
  async mounted() {
    // this.search()
    // if (parseInt(this.localUser.role) === 1) {
    //   this.getMajor(this.localUser.academy_id)
    //   this.formInfo.academy_id = this.localUser.academy_id
    // }
  }
}
</script>

<style scoped>
.form_content .label {
  width: 120px;
}
#dialog_content2 {
  max-height: 200px;
  overflow: auto;
}
</style>
